export const MAIN_CLASS_NAME = 'project-resource-volume';
